import CONSTANTS from "./Constants";

/**
 * found at http://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser
 */
let browserVendor = null
export function checkBrowser() {
    if(browserVendor === null){
        let _browser = null;
        if( (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0 ){
            // Opera 8.0+
            _browser = CONSTANTS.VENDORS.OPERA;
        }else if( typeof InstallTrigger !== 'undefined' ){
            // Firefox 1.0+
            _browser = CONSTANTS.VENDORS.FIREFOX;
        }else if( Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0 || !!window.ApplePaySetupFeature || !!window.safari  || !!document.getCSSCanvasContext){
            // At least Safari 3+: "[object HTMLElementConstructor]"
            _browser = CONSTANTS.VENDORS.SAFARI;
        }else if( /*@cc_on!@*/false || !!document.documentMode ){
            // Internet Explorer 6-11
            _browser = CONSTANTS.VENDORS.IE;
        }else if( /*!isIE &&*/ !!window.StyleMedia ){
            // Edge 20+
            _browser = CONSTANTS.VENDORS.EDGE;
        }else if( !!window.chrome ){
            // Chrome 1+
            _browser = CONSTANTS.VENDORS.CHROME;
        }


        if( (_browser === CONSTANTS.VENDORS.CHROME || _browser === CONSTANTS.VENDORS.OPERA) && !!window.CSS ){
            // Blink engine detection
            _browser = CONSTANTS.VENDORS.BLINK;
        }else if( _browser !== CONSTANTS.VENDORS.CHROME && _browser !== CONSTANTS.VENDORS.OPERA && window.webkitAudioContext !== undefined  ){
            // At least Safari 10
            _browser = CONSTANTS.VENDORS.SAFARI;
        }else if( ! _browser && navigator.webdriver){
            // Chrome Headless from (https://antoinevastel.com/bot%20detection/2018/01/17/detect-chrome-headless-v2.html)
            _browser = CONSTANTS.VENDORS.CHROMEHEADLESS;
        }
        browserVendor = _browser
    }
    return browserVendor;
}

/**
 * Returns a function, that, as long as it continues to be invoked, will not be triggered. The function
 * will be called after it stops being called for N milliseconds. If `immediate` is passed, trigger the
 * function on the leading edge, instead of the trailing.
 * https://davidwalsh.name/javascript-debounce-function
 *
 * @param {Function} func
 * @param {integer} wait
 * @param {bool} immediate
 * @returns {Function}
 */
export function debounce(func, wait, immediate) {
    let timeout;
    return function () {
        let context = this, args = arguments;
        let later = function () {
            timeout = null;
            if (!immediate) {
                func.apply(context, args);
            }
        };
        let callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        window.dtimeout = timeout; // Xamarin.
        if (callNow) {
            func.apply(context, args);
        }
    };
}

/**
 * https://remysharp.com/2010/07/21/throttling-function-calls
 *
 * @param {Function} func
 * @param {Number} threshold
 * @param {Object} scope
 * @returns {Function}
 */
export function throttle (func, threshold, scope) {
    threshold || (threshold = 250);
    var last,
        deferTimer;
    return function () {
        var context = scope || this;

        var now = +new Date,
            args = arguments;
        if (last && now < last + threshold) {
            // hold on to it
            clearTimeout(deferTimer);
            deferTimer = setTimeout(function () {
                last = now;
                func.apply(context, args);
            }, threshold);
        } else {
            last = now;
            func.apply(context, args);
        }
    };
}

/**
 * Write a styletag in the body with the given css and under given id.
 * @param {string} css
 * @param {string} id
 * @param {HTMLElement} appendTarget
 * @public
 */
export function writeStyleTag(css, id, appendTarget){
    let style = appendTarget.querySelector(`#${id}`);
    if( !style ){
        style = document.createElement("style");
        style.setAttribute("id", id);
        style.setAttribute("type", "text/css");
        appendTarget.appendChild(style);
        // }else{
        //     if(style.sheet.rules.length > 0){
        //         style.sheet.deleteRule(0);
        //     }
    }
    // style.sheet.insertRule(css, 0);
    style.innerHTML = css;
}

export function isUuid (str) {
    return /^[0-9A-F]{8}-[0-9A-F]{4}-[4][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i.test(str)
}

export function getElementOffsetInScene (target) {
    let offset = target.offsetTop;
    if (!target.offsetParent.classList.contains('maglrspread')) {
        offset += getElementOffsetInScene(target.offsetParent)
    }
    return offset;
}

export function constructUUID (uuid, layout, spreadId = false) {
    if (spreadId) {
        return `uuid_s${spreadId}_${uuid}_${layout}`
    }
    return `uuid_${uuid}_${layout}`
}

/**
 * Modernizr's touch detection
 *
 * @returns {boolean|*}
 */
export function hasTouch () {
    return ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;
}

export function constructSceneUUID (uuid, layout, spreadId) {
    return `scene_s${spreadId}_${uuid}_${layout}`
}

export function pxToEm (px, scene, ownFontSize) {
    const pxEmRatio = parseFloat(scene.dataset.pxemratio)
    const sceneScale = parseFloat(window.getComputedStyle(scene).getPropertyValue('--sceneScale')) || 1
    return `${(px / sceneScale) * pxEmRatio / ownFontSize}em`
}

export function getOffsetParentsOffset (target) {
    let offset = 0
    while (target.offsetParent) {
        offset += target.offsetParent.offsetTop
        target = target.offsetParent
    }
    return offset
}

/**
 * Checks whether the given element lives inside a stack container.
 * Stack children are in normal document flow (flex/grid) so they don't need
 * a shadow trigger — the element itself is already a reliable scroll target.
 */
function isInsideStack (element) {
    return !!element.closest('.stack')
}

export function createShadowElementForTrigger (element, sceneElement, {direction, maskedMove = false, stickyFor}) {
    // Stack elements are positioned in normal flow (relative, flex/grid children).
    // A shadow trigger would become an extra flow item, adding unwanted height.
    // The element itself is already at the correct scroll position.
    if (isInsideStack(element)) {
        return element
    }

    let triggerTarget = element

    if (maskedMove) {
        triggerTarget = element.closest('.mask-animation-wrap')
    } else if ((element.matches('.link') && element.parentNode.nodeName === 'A') || element.nodeName === 'VIDEO') {
        triggerTarget = element.parentNode
    }

    const existingTrigger = triggerTarget.parentNode.querySelector(`[data-shadow-trigger="${element.id}"][data-direction="${direction}"]`)
    if (existingTrigger) {
        return existingTrigger
    }
    const shadowTrigger = document.createElement('div')
    shadowTrigger.className = 'shadow-trigger element'
    shadowTrigger.setAttribute('data-shadow-trigger', element.getAttribute('id'))
    shadowTrigger.setAttribute('data-direction', direction)
    if (triggerTarget.className.indexOf('grid-float-') > -1) {
        shadowTrigger.classList.add(...Array.from(triggerTarget.classList).filter(name => name.indexOf('float') > -1))
    } else if (triggerTarget.className.indexOf('grid-sticky') > -1) {
        const copyClasses = ['grid-sticky', 'screen-border', 'anchored-top', 'anchored-mid', 'anchored-bottom', 'anchored-left', 'anchored-center', 'anchored-right']
        shadowTrigger.classList.add(...Array.from(triggerTarget.classList).filter(name => copyClasses.includes(name)))
    }
    const computed = window.getComputedStyle(triggerTarget)
    shadowTrigger.style.height = computed.getPropertyValue('--height');

    const fontSize = computed.getPropertyValue('--fontSize')
    if (fontSize) {
        shadowTrigger.style.fontSize = `${fontSize}em`;
    }
    if (element.dataset.gridsettings) {
        shadowTrigger.style.cssText += element.dataset.gridsettings // gridSettings are always on the element itself
    } else {
        shadowTrigger.style.gridArea = computed.gridArea

        if (computed.marginTop !== '0px') {
            shadowTrigger.style.marginTop = pxToEm(parseFloat(computed.marginTop), sceneElement, parseFloat(fontSize) || 1)
        }
        if (computed.marginBottom !== '0px') {
            shadowTrigger.style.marginBottom = pxToEm(parseFloat(computed.marginBottom), sceneElement, parseFloat(fontSize) || 1)
        }
        if (computed.alignSelf === 'end') { // add alignSelf to shadowTrigger for elements below the safezone/beneath canvas
            shadowTrigger.style.alignSelf = computed.alignSelf
        }

        if (computed.position === 'absolute') {
            shadowTrigger.style.position = computed.position
            shadowTrigger.style.top = computed.top
            shadowTrigger.style.left = computed.left
        }
    }

    if (stickyFor) {
        shadowTrigger.style.translate = `0 ${stickyFor}`
    }

    triggerTarget.after(shadowTrigger)

    return shadowTrigger
}

export function isElementInViewport(element) {
    if (!element) {
        return false;
    }
    const rect = element.getBoundingClientRect();
    return rect.top >= 0 && rect.bottom <= window.innerHeight
}

/**
 * Finds the first element in the event's composed path that matches the selector.
 * Use for delegated handlers when the real target can be inside Shadow DOM.
 * @param {Event} event
 * @param {string} selector
 * @returns {Element|null}
 */
// toggle aria-expanded on every trigger that controls the scene/group with the
// given id. Uses ~= (space-separated token match) so an aria-controls listing
// multiple ids is matched correctly and id prefixes do not false-positive.
export function setControllingTriggersExpanded(root, id, value) {
    root.querySelectorAll(`[aria-haspopup][aria-controls~="${id}"]`)
        .forEach((trigger) => trigger.setAttribute('aria-expanded', String(value)));
}

export function findTargetInComposedPath(event, selector) {
    const path = event.composedPath ? event.composedPath() : (event.path || []);
    for (let i = 0; i < path.length; i++) {
        const el = path[i];
        if (el.nodeType === 1 && el.matches && el.matches(selector)) {
            return el;
        }
    }
    return null;
}
